import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './app/store';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.css';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import { persistStore } from 'redux-persist'
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './authConfig';
import { HelmetProvider } from 'react-helmet-async';


const container = document.getElementById('root')!;
let persistor = persistStore(store);
const msalInstance = new PublicClientApplication(msalConfig);

const app = (
  <Provider store={store}>
    <HelmetProvider>
      <BrowserRouter>
        <PersistGate persistor={persistor}>
          <MsalProvider instance={msalInstance}>
            <App />
          </MsalProvider>
        </PersistGate>
      </BrowserRouter>
    </HelmetProvider>
  </Provider>
);

createRoot(container).render(app);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
